/**
 * 兜底把「可能是本地化对象」的字段转成字符串。
 *
 * 背景：部分列表/推荐接口偶发把 robot_name / scene 等字段返回为
 * { en: "..." } 这类对象而非字符串，直接渲染会触发
 * "Objects are not valid as a React child" 导致页面 500。
 */
export const toText = (value: unknown, lang?: string): string => {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return String(value)
  if (typeof value === 'object') {
    const obj = value as Record<string, any>
    const picked = (lang && obj[lang]) ?? obj.en ?? Object.values(obj)[0]
    if (picked == null) return ''
    return typeof picked === 'string' ? picked : String(picked)
  }
  return ''
}
